import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./Label.module.scss.js";
const Label = forwardRef((props, ref) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ jsx("label", { ...rest, ref, className: twMerge(styles["label"], "inline-flex", className), children });
});
export {
  Label as default
};
//# sourceMappingURL=Label.js.map
